// /* eslint func-names: off */
// ;(function () {
//   if (window.subscriptionWidgetInitialized) {
//     /* eslint no-console: off */
//     console.log('Subscription widget already initialized')

//     return
//   }

//   window.subscriptionWidgetInitialized = true
  
//   window.handleFrequencyChange = function(event) {
//     const selectedOption = event.target.selectedOptions[0];
//     const sellingPlanId = selectedOption.value;
//     const variant = event.target.closest('[id^="subscription-variant--"]');
    
//     // Update the hidden selling plan select
//     const hiddenSelect = variant.querySelector('select[name="selling_plan"]');
//     if (hiddenSelect) {
//       hiddenSelect.value = sellingPlanId;
      
//       // Create and dispatch a change event
//       const changeEvent = new Event('change', { bubbles: true });
//       hiddenSelect.dispatchEvent(changeEvent);
//     }
//   }

//   document.addEventListener('DOMContentLoaded', () => {
//     var lastPurchaseType = ''
//     const productForms =
//       document.querySelectorAll('form[action^="/cart"]:not([id*="instal"])') ||
//       []

//     productForms.forEach(productForm => {
//       const productFormId = productForm.getAttribute('id')
//       const variantIdInput = productForm.querySelector('[name="id"]')
//       const sellingPlans =
//         productForm.querySelectorAll('[name="selling_plan"]') || []
//       const variants = productForm.querySelectorAll('[id^="subscription-variant--"]')
//       const parents = Array.from(variants).map(variant => variant.parentElement)

//       // Auto-select subscription option and first frequency
//       variants.forEach(wrapper => {
//         if (wrapper.className.indexOf('subscription-variant--active') !== -1) {
//           // Delay the auto-selection slightly to ensure DOM is ready
//           setTimeout(() => {
//             const subscriptionHeader = wrapper.querySelector('.subscription-option-header input[type="radio"]');
//             const frequencyDropdown = wrapper.querySelector('.frequency-dropdown');
            
//             if (subscriptionHeader) {
//               // Click the subscription radio button
//               subscriptionHeader.click();
              
//               // Select first option in frequency dropdown if exists
//               if (frequencyDropdown && frequencyDropdown.options.length > 0) {
//                 frequencyDropdown.selectedIndex = 0;
//                 const changeEvent = new Event('change', { bubbles: true });
//                 frequencyDropdown.dispatchEvent(changeEvent);
//               }
//             }
//           }, 100);
//         }
//       });

//       const updatePriceDisplay = (wrapper, productPrice) => {
//         console.log('updatePriceDisplay called with wrapper:', wrapper)
        
//         // Find the price container and its elements
//         const priceContainer = document.querySelector('[ref="priceContainer"]')
//         console.log('Price container found:', priceContainer)
        
//         let productPriceElement = null
//         let originalPriceElement = null
//         let comparePriceElement = null
        
//         if (priceContainer) {
//           productPriceElement = priceContainer.querySelector('.subscription-price') || priceContainer.querySelector('.price')
//           originalPriceElement = priceContainer.querySelector('.regular-price')
//           comparePriceElement = priceContainer.querySelector('.compare-at-price')
//         }

//         console.log('Price elements found:', {
//           productPriceElement,
//           originalPriceElement,
//           comparePriceElement
//         })

//         const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
//         console.log('Selling plans select:', sellingPlans)
        
//         // Fix: Use selectedOptions or options[selectedIndex] instead of :checked
//         const sellingPlan = sellingPlans.selectedOptions[0] || sellingPlans.options[sellingPlans.selectedIndex]
//         console.log('Selected selling plan:', sellingPlan)

//         if (!sellingPlan) {
//           console.log('No selling plan selected, cannot update prices')
//           return
//         }

//         document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "none"})

//         const discountPercentage = sellingPlan.dataset.discount
//         const originalPrice = wrapper.dataset.price
//         const discountedPrice = sellingPlan.dataset.price
        
//         console.log('Price data:', {
//           discountPercentage,
//           originalPrice,
//           discountedPrice
//         })

//         const discountElement = wrapper.querySelector('.subscription-variant-discount')

//         // not displayed for subscription-only (e.g. 3-month packs)
//         if (discountElement) {
//           const discountPercentElement = discountElement.querySelector(
//             '.subscription-variant-discount-percentage'
//           )
//           const discountPriceElement = discountElement.querySelector(
//             '.subscription-variant-discount-price'
//           )

//           if (discountPercentage !== '0%') {
//             discountPercentElement.textContent = discountPercentage
//             discountPriceElement.textContent = discountedPrice
//             discountElement.style.display = ''
//           } else {
//             discountElement.style.display = 'none'
//           }
//         }

//         // Update the subscription widget's internal price displays
//         const subscriptionPriceElement = wrapper.querySelector('[data-widget-price-sub-price]')
//         const onetimePriceElement = wrapper.querySelector('[data-widget-price-onetime]')
//         const subCompareElement = wrapper.querySelector('[data-widget-price-sub-compare]')
        
//         console.log('Subscription widget internal price elements:', {
//           subscriptionPriceElement,
//           onetimePriceElement,
//           subCompareElement
//         })

//         if (subscriptionPriceElement) {
//           console.log('Updating subscription price element to:', discountedPrice)
//           subscriptionPriceElement.textContent = discountedPrice
//         }

//         if (onetimePriceElement) {
//           console.log('Updating onetime price element to:', originalPrice)
//           onetimePriceElement.textContent = originalPrice
//         }

//         if (subCompareElement) {
//           console.log('Updating subscription compare price to:', originalPrice)
//           subCompareElement.textContent = originalPrice
//         } 
//         // console.log("goodbye")
//         // console.log("discountedPrice",discountedPrice)
//         // const discountPriceSpan = document.querySelector('span#discount-price');
//         // const mainPriceSpan = document.querySelector('span#main-price');
//         // console.log(discountPrice);
//         // discountPriceSpan.style.display = 'block'
//         // discountPriceSpan.innerText = originalPrice
//         // mainPriceSpan.innerText

//         // ALWAYS show subscription pricing in main product area

//         // Calculate subscription price (20% discount)

//         const subscriptionDiscount = 20
//         const discountMultiplier = (100 - subscriptionDiscount) / 100
//         const originalPriceNum = parseFloat(originalPrice.replace(/[^0-9.]/g, ''))
//         const subscriptionPrice = originalPriceNum * discountMultiplier

//         // Format subscription price to match original format

//         const formattedSubscriptionPrice = new Intl.NumberFormat('en-US', {
//         style: 'currency',
//         currency: 'USD',
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//         }).format(subscriptionPrice)

//         if (productPriceElement) {
//           console.log('ALWAYS showing subscription price:', formattedSubscriptionPrice)
//           productPriceElement.textContent = formattedSubscriptionPrice
//         } else {
//           console.log('productPriceElement not found!')
//         }

//         if (originalPriceElement) {
//           console.log('ALWAYS showing original price as strikethrough:', originalPrice);
//           originalPriceElement.textContent = originalPrice;
//           originalPriceElement.style.display = ''
//           originalPriceElement.style.textDecoration = 'line-through'
//           originalPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
//         } else {
//           console.log('originalPriceElement not found!')
//         }
        
//         console.log('updatePriceDisplay completed')
//       }
//       const resetPriceDisplay = wrapper => {
//         console.log('resetPriceDisplay called with wrapper:', wrapper)
        
//         // Find the price container and its elements
//         const priceContainer = document.querySelector('[ref="priceContainer"]')
//         console.log('Price container found:', priceContainer)
        
//         let productPriceElement = null
//         let originalPriceElement = null
        
//         if (priceContainer) {
//           productPriceElement = priceContainer.querySelector('.subscription-price') || priceContainer.querySelector('.price')
//           originalPriceElement = priceContainer.querySelector('.regular-price')
//         }

//         // console.log("originalPriceElement",originalPriceElement)
//         // console.log("productPriceElement",productPriceElement)

//         // document.querySelector('.afterpay_wrap.main').style.display = "block";
//         document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "block"})

//         if (wrapper) {
//           const originalPrice = wrapper.dataset.price
//           const productTypes = wrapper.querySelectorAll('input[name="purchase_type"]');
//           if (productTypes.length <= 1) return;
//           // ALWAYS show subscription pricing in main product area
//           // Calculate subscription price (20% discount)
//           const subscriptionDiscount = 20
//           const discountMultiplier = (100 - subscriptionDiscount) / 100
//           const originalPriceNum = parseFloat(originalPrice.replace(/[^0-9.]/g, ''))
//           const subscriptionPrice = originalPriceNum * discountMultiplier

//           // Format subscription price to match original format
//           const formattedSubscriptionPrice = new Intl.NumberFormat('en-US', {
//           style: 'currency',
//           currency: 'USD',
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2
//           }).format(subscriptionPrice)
//           console.log("ALWAYS showing subscription price in reset:", formattedSubscriptionPrice);

//           if (productPriceElement) {
//             productPriceElement.textContent = formattedSubscriptionPrice
//           }
//           if (originalPriceElement) {
//             originalPriceElement.textContent = originalPrice
//             originalPriceElement.style.display = ''
//             originalPriceElement.style.textDecoration = 'line-through'
//             originalPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
//           }
//         }

//         // Note: originalPriceElement styling is handled above in the wrapper condition
//       }

//       const updateButtonPrice = (wrapper, isSubscription) => {
//         const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
//         if (!buttonPriceElement) return

//         const variantId = wrapper.dataset.variantId
//         if (!variantId) return

//         // Get the current variant price from the wrapper's data-price attribute
//         const priceText = wrapper.dataset.price || '$0.00'
//         const oneTimePrice = parseFloat(priceText.replace(/[^0-9.]/g, ''))
        
//                   let currentPrice = oneTimePrice
        
//         if (isSubscription) {
//           // Calculate subscription price with discount
//           const subscriptionDiscount = 20 // Default 20% discount
//           const discountMultiplier = (100 - subscriptionDiscount) / 100
//           const subscriptionPrice = oneTimePrice * discountMultiplier
//           currentPrice = subscriptionPrice
          
//           // Format the price
//           const formattedPrice = subscriptionPrice.toFixed(2)
//           buttonPriceElement.innerHTML = `• $${formattedPrice}`
//           // Update main price container to show subscription pricing
//           updateMainPriceContainer(subscriptionPrice, oneTimePrice, true)
//         } else {
//           // Show one-time price
//           const formattedPrice = oneTimePrice.toFixed(2)
//           buttonPriceElement.innerHTML = `• $${formattedPrice}`
          
//           // Update main price container to show one-time pricing
//           updateMainPriceContainer(oneTimePrice, oneTimePrice, false)
//         }
        
//         // Update Afterpay installments
//         updateAfterpayInstallments(currentPrice)
//       }

//       const updateAfterpayInstallments = (price) => {
//         const afterpayElement = document.getElementById('afterpay_instalments')
//         if (!afterpayElement) return

//         // Calculate installment amount (price divided by 4)
//         const installmentAmount = price / 4
        
//         // Format as currency
//         const formattedInstallment = new Intl.NumberFormat('en-US', {
//           style: 'currency',
//           currency: 'USD',
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2
//         }).format(installmentAmount)

//         afterpayElement.textContent = formattedInstallment
//       }

//       const syncToStickyBar = (isSubscription) => {
//         const stickyBar = document.querySelector('[data-sticky-add-to-cart]')
//         if (!stickyBar) return
        
//         const stickyOneTimeRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="onetime"]')
//         const stickySubscriptionRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="subscription"]')
        
//         if (isSubscription && stickySubscriptionRadio) {
//           stickySubscriptionRadio.checked = true
//           stickySubscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }))
//         } else if (!isSubscription && stickyOneTimeRadio) {
//           stickyOneTimeRadio.checked = true
//           stickyOneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }))
//         }
//       }

//       const updateMainPriceContainer = (displayPrice, originalPrice, isSubscription) => {
//         const priceContainer = document.querySelector('[ref="priceContainer"]')
//         if (!priceContainer) return

//         const subscriptionPriceElement = priceContainer.querySelector('.subscription-price')
//         const regularPriceElement = priceContainer.querySelector('.regular-price')
//         const subscriptionBadge = priceContainer.querySelector('.subscription-badge')
        
//         if (!subscriptionPriceElement || !regularPriceElement) return

//         // Format prices as currency
//         const formatPrice = (price) => {
//           return new Intl.NumberFormat('en-US', {
//             style: 'currency',
//             currency: 'USD',
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//           }).format(price)
//         }

//         // ALWAYS show subscription pricing in main product area
//         // Calculate subscription price (20% discount)
//         const subscriptionDiscount = 20
//         const discountMultiplier = (100 - subscriptionDiscount) / 100
//         const subscriptionPrice = originalPrice * discountMultiplier
//         // Always show subscription price as main price, regular price as crossed out
//         subscriptionPriceElement.textContent = formatPrice(subscriptionPrice)
        
//         // Always ensure subscription styling
//         subscriptionPriceElement.style.color = '#181818'
//         subscriptionPriceElement.style.textDecoration = 'none'
//         regularPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
//         regularPriceElement.style.textDecoration = 'line-through'
//         regularPriceElement.style.display = 'block'
        
//         // Show subscription badge if it exists
//         if (subscriptionBadge) {
//           subscriptionBadge.style.display = ''
//         }

//       }

//       sellingPlans.forEach(el => el.setAttribute('form', productFormId))

//       variants.forEach(wrapper => {
//         const purchaseTypes = wrapper.querySelectorAll(
//           'input[name="purchase_type"]'
//         )
//         purchaseTypes.forEach(purchaseType => {
//           purchaseType.addEventListener('click', e => {
//             // switch toggle
//             productForm.querySelectorAll('.rc_block__type').forEach(el => {
//               // override theme js
//               el.style.display = ''
//               el.classList.remove('rc_block__type--active')
//             })

//             const purchaseType = e.target
//             const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
//             const block = purchaseType.closest('.rc_block__type')

//             // handle subscription option not output
//             block && block.classList.add('rc_block__type--active')

//             lastPurchaseType = purchaseType.value
//             const purchaseTypes = wrapper.querySelectorAll('input[name="purchase_type"]')

//             if (lastPurchaseType === 'autodeliver' && purchaseTypes.length > 1) {
//               sellingPlans.disabled = false
//               // console.log("=>updatePriceDisplay")
//               // console.log(wrapper)
//               // This is all handled in theme.js now
//               // updatePriceDisplay(wrapper)
//               updateButtonPrice(wrapper, true) // Update button to show subscription price
//               syncToStickyBar(true) // Sync to sticky bar
//             } else {
//               sellingPlans.disabled = true
//               // console.log("=>resetPriceDisplay")
//               // console.log(wrapper)
//               resetPriceDisplay(wrapper)
//               updateButtonPrice(wrapper, false) // Update button to show one-time price
//               syncToStickyBar(false)
//             }
//           })
//         })
//       })

//       // Listen for variant update events from the theme
//       const closestSection = productForm.closest('.shopify-section, dialog')
//       if (closestSection) {
//         console.log('Setting up variant update listener for:', productForm)
        
//         closestSection.addEventListener('variant:update', (event) => {
//           console.log('Variant update event received:', event.detail)
          
//           // Don't hide/show wrappers - just update prices directly
//           const newVariantPrice = event.detail.resource.price / 100
//           const formattedPrice = `$${newVariantPrice.toFixed(2)}`
          
//           console.log('New variant price:', formattedPrice)
          
//           // Update all subscription wrapper data-price attributes
//           variants.forEach(wrapper => {
//             console.log('Updating wrapper price data:', wrapper)
//             wrapper.dataset.price = formattedPrice
//           })
          
//           // Find the currently active wrapper (the one that's visible)
//           const activeWrapper = productForm.querySelector('.subscription-variant--active')
//           console.log('Active wrapper found:', activeWrapper)
          
//           if (activeWrapper) {
//             // Update selling plan data if available
//             const sellingPlansSelect = activeWrapper.querySelector('[name="selling_plan"]')
//             console.log('Selling plans select:', sellingPlansSelect)
//             console.log('Selling plan allocations:', event.detail.resource.selling_plan_allocations)
            
//             if (sellingPlansSelect && event.detail.resource.selling_plan_allocations) {
//               // Clear existing options
//               sellingPlansSelect.innerHTML = ''
              
//               // Add new selling plan options
//               event.detail.resource.selling_plan_allocations.forEach(allocation => {
//                 console.log('Processing allocation:', allocation)
                
//                 const option = document.createElement('option')
//                 option.value = allocation.selling_plan_id
//                 option.dataset.price = `$${(allocation.price / 100).toFixed(2)}`
                
//                 // Safely get discount percentage from price_adjustments
//                 let discountPercentage = '0%'
//                 if (allocation.price_adjustments && 
//                     allocation.price_adjustments.length > 0 &&
//                     allocation.price_adjustments[0]) {
//                   discountPercentage = `${allocation.price_adjustments[0].value || 0}%`
//                 }
//                 option.dataset.discount = discountPercentage
                
//                 // Use a default name since the selling plan name might not be directly available
//                 option.textContent = `Subscription Plan ${allocation.selling_plan_id}`
//                 sellingPlansSelect.appendChild(option)
//                 console.log('Added selling plan option:', allocation.selling_plan_id, 'with discount:', discountPercentage)
//               })
              
//               // Select the first option if available
//               if (sellingPlansSelect.options.length > 0) {
//                 sellingPlansSelect.selectedIndex = 0
                
//                 // Trigger change event to update hidden selling plan select
//                 const changeEvent = new Event('change', { bubbles: true });
//                 sellingPlansSelect.dispatchEvent(changeEvent);
//               }
              
//               console.log('Updated selling plan options')
//             }

//             // Check what purchase type is currently selected
//             const currentPurchaseType = activeWrapper.querySelector('input[name="purchase_type"]:checked')
//             const purchaseTypes = activeWrapper.querySelectorAll('input[name="purchase_type"]')
//             console.log('Current purchase type:', currentPurchaseType?.value)
            
//             if (currentPurchaseType && currentPurchaseType.value === 'autodeliver' && purchaseTypes.length > 1) {
//               // Update subscription pricing
//               console.log('Updating subscription pricing')
//               updatePriceDisplay(activeWrapper)
//               updateButtonPrice(activeWrapper, true)
//             } else {
//               // Update one-time pricing
//               console.log('Updating one-time pricing')
//               resetPriceDisplay(activeWrapper)
//               updateButtonPrice(activeWrapper, false)
//             }
//           } else {
//             console.log('No active subscription wrapper found - updating one-time pricing directly')
//             // No active subscription wrapper - update one-time pricing directly
//             const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
//             if (buttonPriceElement) {
//               buttonPriceElement.innerHTML = `• ${formattedPrice}`
//               updateAfterpayInstallments(newVariantPrice)
//               updateMainPriceContainer(newVariantPrice, newVariantPrice, false)
//             }
//           }
//         })
//       } else {
//         console.log('No closest section found for:', productForm)
//       }

//       variants.forEach(wrapper => {
//         if (wrapper.className.indexOf('subscription-variant--active') === -1) {
//           wrapper.remove()
//         } else if (wrapper.dataset.subscriptionOnly === 'true') {
//           const purchaseType = wrapper.querySelector(
//             'input[name="purchase_type"].rc_radio__autodeliver'
//           )
//           // console.log("purchaseType",purchaseType)
//           // trigger theme js things
//           purchaseType.click()

//           setTimeout(() => {
//             // again for good measure
//             purchaseType.click()
//           }, 500)
//         }
//       })
//     })
//   })

//   // Global function for deselectSubscription onclick handler
//   window.deselectSubscription = function(event) {
//     // This function is called when one-time purchase option is clicked
//     // The actual logic is handled by the radio button event listeners above
//     // This is just to prevent the error since it's referenced in the HTML
//   }
// })()
/* eslint func-names: off */


;(function () {
    if (window.subscriptionWidgetInitialized) {
      /* eslint no-console: off */
      // console.log('Subscription widget already initialized')
  
      return
    }
  
    window.subscriptionWidgetInitialized = true
    
    window.handleFrequencyChange = function(event) {
      const selectedOption = event.target.selectedOptions[0];
      const sellingPlanId = selectedOption.value;
      const variant = event.target.closest('[id^="subscription-variant--"]');
      
      // Update the visual display text if it exists (for custom widget)
      const displayLabel = event.target.closest('.select-wrapper')?.querySelector('[data-selected-plan-text]');
      if (displayLabel) {
        displayLabel.textContent = selectedOption.textContent.trim();
      }

      // Update the hidden selling plan select
      const hiddenSelect = variant.querySelector('select[name="selling_plan"]');
      if (hiddenSelect) {
        hiddenSelect.value = sellingPlanId;
        
        // Create and dispatch a change event
        const changeEvent = new Event('change', { bubbles: true });
        hiddenSelect.dispatchEvent(changeEvent);
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      const getCurrencySymbol = () => window.cartCurrencySymbolActive || '£'
      const getCurrencyCode = () => window.shopCurrency || window.Shopify?.currency?.active || 'GBP'

      const formatStorePrice = (amount) => {
        const numericAmount = Number(amount)
        if (isNaN(numericAmount)) return ''

        return new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: getCurrencyCode(),
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(numericAmount)
      }

      // Format any [data-cents] money element from its cents Integer so the visible text
      // matches Liquid `| money` (always two decimal places) and is immune to
      // `money_without_trailing_zeros` Float quirks and third-party DOM rewrites.
      const formatCentsToVisibleText = (cents) => {
        const c = parseInt(cents, 10)
        if (isNaN(c) || c < 0) return null
        return formatStorePrice(c / 100)
      }

      const parseCentsToDollars = (cents) => {
        const parsed = parseInt(cents, 10)
        if (isNaN(parsed)) return null
        return parsed / 100
      }

      const isSubscriptionOnlyWrapper = (wrapper) => {
        if (!wrapper) return false
        if (wrapper.dataset.subscriptionOnly === 'true') return true
        if (wrapper.dataset.subscriptionOnly === 'false') return false
        const oneTimeRadio = wrapper.querySelector('input[name="purchase_type"][value=""]')
        const subscriptionRadio = wrapper.querySelector('input[name="purchase_type"][value="autodeliver"]')
        return !!subscriptionRadio && !oneTimeRadio
      }

      const getSubscriptionDisplayPrice = (wrapper) => {
        const priceContainer = document.querySelector('[ref="priceContainer"]')
        const containerPrice = parseCentsToDollars(priceContainer?.dataset?.subscriptionCents)
        if (containerPrice !== null) return containerPrice

        const wrapperPrice = parseCentsToDollars(wrapper?.dataset?.subscriptionCents)
        if (wrapperPrice !== null) return wrapperPrice

        const widgetPriceElement = wrapper?.querySelector('[data-widget-price-sub-price]')
        const widgetCents = widgetPriceElement?.dataset?.cents
        const widgetPrice = parseCentsToDollars(widgetCents)
        if (widgetPrice !== null) return widgetPrice

        if (widgetPriceElement?.textContent?.trim()) {
          const parsed = parseFloat(widgetPriceElement.textContent.replace(/[^0-9.]/g, ''))
          if (!isNaN(parsed) && parsed > 0) return parsed
        }

        return null
      }

      const getCompareDisplayPrice = (wrapper) => {
        const priceContainer = document.querySelector('[ref="priceContainer"]')
        const containerCompare = parseCentsToDollars(priceContainer?.dataset?.compareCents)
        if (containerCompare !== null) return containerCompare

        const wrapperCompare = parseCentsToDollars(wrapper?.dataset?.compareCents)
        if (wrapperCompare !== null) return wrapperCompare

        const priceText = wrapper?.dataset?.price || `${getCurrencySymbol()}0.00`
        return parseFloat(priceText.replace(/[^0-9.]/g, ''))
      }

      /**
       * Resolves a translated string from Theme.translations and fills its tokens.
       * @param {string} key - Translation key
       * @param {Record<string, string|number>} [replacements] - Token to value map, e.g. { __PERCENT__: 20 }
       * @param {string} [fallback] - Used when the key is missing
       * @returns {string}
       */
      const formatCopy = (key, replacements = {}, fallback = '') => {
        if (typeof window.Theme?.formatCopy === 'function') {
          return window.Theme.formatCopy(key, replacements, fallback)
        }

        const translations = window.Theme?.translations || {}
        let template = String(translations[key] || fallback).replaceAll('&amp;', '&')

        for (const [token, value] of Object.entries(replacements)) {
          template = template.split(token).join(String(value))
        }

        return template
      }

      /**
       * Price text as sighted users see it, ignoring the visually-hidden label.
       * @param {Element|null} element
       * @returns {string}
       */
      const getVisiblePriceText = (element) => {
        if (!element) return ''

        let text = ''
        for (const node of element.childNodes) {
          if (node.nodeType === Node.TEXT_NODE) {
            text += node.textContent
          } else if (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('visually-hidden')) {
            text += node.textContent
          }
        }

        return text.trim()
      }

      /**
       * Replaces a price element's visible text, keeping (or creating from labelKey)
       * the visually-hidden "Regular price" / "Sale price" label for screen readers.
       * @param {Element|null} element
       * @param {string} formattedPrice
       * @param {string} [labelKey] - Translation key for the hidden label, e.g. 'price_sale'
       * @returns {void}
       */
      const setPriceText = (element, formattedPrice, labelKey) => {
        if (!element) return

        const hiddenLabel = element.querySelector(':scope > .visually-hidden')
        if (hiddenLabel) {
          while (hiddenLabel.nextSibling) {
            hiddenLabel.nextSibling.remove()
          }
          hiddenLabel.insertAdjacentText('afterend', formattedPrice)
          return
        }

        if (labelKey) {
          const label = formatCopy(labelKey, {}, '')
          if (label) {
            element.replaceChildren()
            const span = document.createElement('span')
            span.className = 'visually-hidden'
            span.textContent = `${label}\u00a0`
            element.append(span, formattedPrice)
            return
          }
        }

        element.textContent = formattedPrice
      }

      document
        .querySelectorAll('[data-cents]')
        .forEach((el) => {
          const formatted = formatCentsToVisibleText(el.dataset.cents)
          if (formatted && getVisiblePriceText(el) !== formatted) {
            setPriceText(el, formatted)
          }
        })

      const syncOneTimeComparePrice = (priceContainer) => {
        if (!priceContainer) return

        const priceCents = parseInt(priceContainer.dataset.subscriptionCents, 10)
        const otpCompareCents = parseInt(priceContainer.dataset.onetimeCompareCents, 10)
        const subscriptionCompareCents = parseInt(priceContainer.dataset.compareCents, 10)
        const compareCents =
          !isNaN(otpCompareCents) && otpCompareCents > 0 ? otpCompareCents : subscriptionCompareCents
        const compareEl = priceContainer.querySelector('.compare-at-price')

        if (!compareEl) return

        if (!isNaN(compareCents) && !isNaN(priceCents) && compareCents > priceCents) {
          const compareFormatted = formatCentsToVisibleText(compareCents)
          if (compareFormatted) {
            compareEl.textContent = compareFormatted
            compareEl.style.display = ''
          }
        } else {
          compareEl.textContent = ''
          compareEl.style.display = 'none'
        }
      }

      // Collection/product cards: sync visible prices from Liquid data-*-cents on priceContainer.
      const syncCollectionGridPrices = () => {
        document.querySelectorAll('[ref="priceContainer"][data-subscription-cents]').forEach((container) => {
          if (container.classList.contains('priceContainer--pdp')) return

          const subCents = parseInt(container.dataset.subscriptionCents, 10)
          const compareCents = parseInt(container.dataset.compareCents, 10)
          if (isNaN(subCents) || subCents < 0) return

          const subFormatted = formatCentsToVisibleText(subCents)
          const priceEl = container.querySelector('.price, .subscription-price')
          if (priceEl && subFormatted) {
            setPriceText(priceEl, subFormatted, 'price_sale')
          }

          const compareEl = container.querySelector('.compare-at-price')
          const isOneTimeCard = container.querySelector('.price') && !container.querySelector('.subscription-price')

          if (isOneTimeCard) {
            syncOneTimeComparePrice(container)
          } else if (compareEl && !isNaN(compareCents) && compareCents > subCents) {
            const compareFormatted = formatCentsToVisibleText(compareCents)
            if (compareFormatted) {
              compareEl.textContent = compareFormatted
              compareEl.style.display = ''
            }
          } else if (compareEl) {
            compareEl.textContent = ''
            compareEl.style.display = 'none'
          }
        })
      }

      syncCollectionGridPrices()

      var lastPurchaseType = ''
      const productForms =
        document.querySelectorAll('form[action^="/cart"]:not([id*="instal"])') ||
        []
  
      productForms.forEach(productForm => {
        const productFormId = productForm.getAttribute('id')
        const variantIdInput = productForm.querySelector('[name="id"]')
        const sellingPlans =
          productForm.querySelectorAll('[name="selling_plan"]') || []
        const variants = productForm.querySelectorAll('[id^="subscription-variant--"]')
        const parents = Array.from(variants).map(variant => variant.parentElement)

        // Subscription-only packs have a single autodeliver radio. Do not treat
        // that as OTP just because purchaseTypes.length is 1.
        /**
         * @param {HTMLElement} wrapper - [id^="subscription-variant--"] wrapper
         * @param {string|null|undefined} purchaseValue - Checked purchase_type value
         * @returns {boolean}
         */
        const isSubscriptionPurchase = (wrapper, purchaseValue) => {
          if (wrapper.dataset.subscriptionOnly === 'true') {
            return true
          }

          return purchaseValue === 'autodeliver'
        }

        // Auto-select subscription option and first frequency
        variants.forEach(wrapper => {
          if (wrapper.className.indexOf('subscription-variant--active') !== -1) {
            // Delay the auto-selection to let Shopify's discount logic run first
            // Then our click will override with the correct subscription price
            setTimeout(() => {
              const subscriptionHeader = wrapper.querySelector('.subscription-option-header input[type="radio"]');
              const frequencyDropdown = wrapper.querySelector('.frequency-dropdown');
              
              if (subscriptionHeader) {
                // Click the subscription radio button
                subscriptionHeader.click();
                
                // Select first option in frequency dropdown if exists
                if (frequencyDropdown && frequencyDropdown.options.length > 0) {
                  frequencyDropdown.selectedIndex = 0;
                  const changeEvent = new Event('change', { bubbles: true });
                  frequencyDropdown.dispatchEvent(changeEvent);
                }
              }
            }, 100);
          }
        });
  
        // Initialize prices on page load - check if OTP is already selected
        setTimeout(() => {
          
          variants.forEach(wrapper => {
            // Skip wrappers that were removed from the DOM during init
            // (non-active wrappers are removed at the end of the init block)
            if (!wrapper.isConnected) return
            
            const oneTimeRadio = wrapper.querySelector('input[name="purchase_type"][value=""]:checked')
            const subscriptionRadio = wrapper.querySelector('input[name="purchase_type"][value="autodeliver"]:checked')

            if (subscriptionRadio) {
              updateButtonPrice(wrapper, true)
            } else if (oneTimeRadio) {
              updateButtonPrice(wrapper, false)
            } else if (isSubscriptionOnlyWrapper(wrapper)) {
              updateButtonPrice(wrapper, true)
            }
          })
        }, 200)
  
        const updatePriceDisplay = (wrapper, productPrice, freshForm) => {
          // Use fresh form reference if provided, otherwise fall back to old reference
          const formToUse = freshForm || productForm
          
          // The subscription widget has its OWN price elements inside the wrapper
          // Use widget-specific selectors, not the main product price selectors
          const productPriceElement = wrapper.querySelector('[data-widget-price-sub-price]')
          const originalPriceElement = wrapper.querySelector('[data-widget-price-sub-compare]')
          const comparePriceElement = document.querySelector('[data-compare-price-main]')
  
          const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
          if (!sellingPlans) {
            // console.log('No selling plans found in wrapper - skipping price update')
            return
          }
          
          const sellingPlan = sellingPlans.querySelector('option:checked')
          if (!sellingPlan) {
            // console.log('No checked selling plan found - skipping price update')
            return
          }
  
  
          document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "none"})
  
  
          const discountPercentage =
            wrapper.dataset.subscriptionDiscount > 0
              ? `${wrapper.dataset.subscriptionDiscount}%`
              : sellingPlan.dataset.discount
          const originalPrice =
            formatCentsToVisibleText(wrapper.dataset.compareCents) || wrapper.dataset.price
          // Prefer Liquid-stamped cents so compare-price-new-logic stays on
          // compare-at ($207 → $148.83) instead of OTP ($186 → $133.73).
          const stampedSubPrice = formatCentsToVisibleText(wrapper.dataset.subscriptionCents)
          const discountedPrice = stampedSubPrice || sellingPlan.dataset.price

          // Keep "SUBSCRIBE AND SAVE X%" / buybox SAVE badge in sync with metafield %
          const discountPctNumber = String(discountPercentage || '').replace('%', '').trim()
          const labelTextSpan = wrapper.querySelector('.rc_label__autodeliver > span:not(.savings)')
          const discountBadge = wrapper.querySelector('.discount-badge')
          const buyboxLabel = wrapper.querySelector('.option-label.subscription-label')

          if (discountPctNumber && discountPctNumber !== '0') {
            wrapper.dataset.subscriptionDiscount = discountPctNumber
            if (labelTextSpan) {
              labelTextSpan.textContent = formatCopy(
                'subscribe_and_save_and_percent',
                { __PERCENT__: discountPctNumber },
                `SUBSCRIBE AND SAVE ${discountPctNumber}%`
              )
            }
            if (discountBadge) {
              if (buyboxLabel) {
                buyboxLabel.textContent = formatCopy('subscribe_and', {}, 'SUBSCRIBE &')
              }
              discountBadge.textContent = formatCopy(
                'save_percent',
                { __PERCENT__: discountPctNumber },
                `SAVE ${discountPctNumber}%`
              )
              discountBadge.style.display = 'inline-flex'
            } else if (buyboxLabel) {
              buyboxLabel.textContent = formatCopy('subscribe', {}, 'SUBSCRIBE')
            }
          } else {
            wrapper.dataset.subscriptionDiscount = '0'
            if (labelTextSpan) {
              labelTextSpan.textContent = formatCopy('subscribe', {}, 'SUBSCRIBE')
            }
            if (buyboxLabel) {
              buyboxLabel.textContent = formatCopy('subscribe', {}, 'SUBSCRIBE')
            }
            if (discountBadge) {
              discountBadge.style.display = 'none'
            }
          }
          
          if (!productPriceElement) {
            // console.log('Product price element not found - skipping price update')
            return
          }
  
          const discountElement = wrapper.querySelector('.subscription-variant-discount')
  
          // not displayed for subscription-only (e.g. 3-month packs)
          if (discountElement) {
            const discountPercentElement = discountElement.querySelector(
              '.subscription-variant-discount-percentage'
            )
            const discountPriceElement = discountElement.querySelector(
              '.subscription-variant-discount-price'
            )
  
            if (discountPercentage !== '0%') {
              discountPercentElement.textContent = discountPercentage
              discountPriceElement.textContent = discountedPrice
              discountElement.style.display = ''
            } else {
              discountElement.style.display = 'none'
            }
          } 
          // console.log("goodbye")
          // console.log("discountedPrice",discountedPrice)
          // const discountPriceSpan = document.querySelector('span#discount-price');
          // const mainPriceSpan = document.querySelector('span#main-price');
          // console.log(discountPrice);
          // discountPriceSpan.style.display = 'block'
          // discountPriceSpan.innerText = originalPrice
          // mainPriceSpan.innerText
  
          productPriceElement.textContent = discountedPrice
  
          if (originalPriceElement) {
            if (
              discountedPrice === originalPrice ||
              (comparePriceElement && comparePriceElement.textContent.trim() !== '')
            ) {
              originalPriceElement.textContent = ''
              originalPriceElement.style.display = 'none'
            } else {
              originalPriceElement.textContent = originalPrice
              originalPriceElement.style.display = ''
            }
          }
        }
        const resetPriceDisplay = (wrapper, freshForm) => {
          // Use fresh form reference if provided, otherwise fall back to old reference
          const formToUse = freshForm || productForm
          
          // The subscription widget has its OWN one-time price element inside the wrapper
          // Use widget-specific selector for one-time purchase
          const productPriceElement = wrapper.querySelector('[data-widget-price-onetime]')
          const originalPriceElement = null // One-time doesn't have a compare price in the widget
  
          // console.log("originalPriceElement",originalPriceElement)
          // console.log("productPriceElement",productPriceElement)
  
          // document.querySelector('.afterpay_wrap.main').style.display = "block";
          document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "block"})
  
          if (wrapper) {
            const originalPrice = wrapper.dataset.price
            // console.log('Resetting to original price:', originalPrice)
            
            if (productPriceElement) {
              productPriceElement.textContent = originalPrice
            }
            
            // Reset regular price element properly
            if (originalPriceElement) {
              // For one-time purchase, check if there's a compare-at price
              if (comparePriceElement && comparePriceElement.textContent && comparePriceElement.textContent.trim() !== '') {
                // There's a compare-at price, so show the regular price as struck through
                originalPriceElement.textContent = comparePriceElement.textContent
                originalPriceElement.style.removeProperty('display')
                originalPriceElement.style.display = ''
                // console.log('One-time mode - showing regular price element with compare-at price')
              } else {
                // No compare-at price, hide the regular price element
                originalPriceElement.textContent = ''
                originalPriceElement.style.display = 'none'
                // console.log('One-time mode - hiding regular price element - no compare-at price')
              }
              // console.log('Reset originalPriceElement display style:', originalPriceElement.style.display)
            }
          }
          
          // console.log('resetPriceDisplay completed')
        }

        const updateButtonPrice = (wrapper, isSubscription) => {
          // console.log('[updateButtonPrice] Called:', { isSubscription, variantId: wrapper?.dataset?.variantId })
          
          const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
          if (!buttonPriceElement) {
            // console.log('[updateButtonPrice] Button price element NOT found')
            return
          }

          const variantId = wrapper.dataset.variantId
          if (!variantId) {
            // console.log('[updateButtonPrice] Variant ID NOT found')
            return
          }

          // Get the current variant price from the wrapper's data-price attribute (fallback)
          let priceText = wrapper.dataset.price || `${getCurrencySymbol()}0.00`
          let oneTimePrice = getCompareDisplayPrice(wrapper)
          
          // console.log('[updateButtonPrice] One-time price from wrapper:', oneTimePrice)
          
          // Read the price from the widget element based on selection
          // Subscription: read from [data-widget-price-sub-price] (inside wrapper)
          // One-time: read from [data-widget-price-onetime] (outside wrapper, sibling element)
          // These elements are updated by Liquid after DOM morphs, so we read from them
          let displayPrice = oneTimePrice // Default fallback
          
          if (isSubscription) {
            const subscriptionDisplayPrice = getSubscriptionDisplayPrice(wrapper)
            if (subscriptionDisplayPrice !== null) {
              displayPrice = subscriptionDisplayPrice
            }
          } else {
            // Read one-time price from widget element
            // IMPORTANT: Both subscription and one-time use [data-widget-price-sub-price]
            // But they're in different contexts:
            // - Subscription: [data-widget-price-sub-price] inside wrapper/subscription section
            // - One-time: [data-widget-price-sub-price] inside [data-one-time-selector]
            let widgetPriceElement = null
            
            // First try: look for [data-widget-price-onetime] (if it exists in Liquid)
            widgetPriceElement = productForm.querySelector('[data-widget-price-onetime]')
            if (!widgetPriceElement) {
              widgetPriceElement = document.querySelector('[data-widget-price-onetime]')
            }
            
            // Second try: look for [data-widget-price-sub-price] inside [data-one-time-selector]
            // This is the actual element that gets populated for one-time purchase (same name as subscription, different context)
            if (!widgetPriceElement) {
              const oneTimeSelector = productForm.querySelector('[data-one-time-selector]')
              if (oneTimeSelector) {
                widgetPriceElement = oneTimeSelector.querySelector('[data-widget-price-sub-price]')
                // console.log('[updateButtonPrice] OTP mode - found in [data-one-time-selector]:', {
                //   found: !!widgetPriceElement,
                //   content: widgetPriceElement?.textContent?.trim()
                // })
              }
            }
            
            // Fallback: search entire document for one-time selector
            if (!widgetPriceElement) {
              const oneTimeSelector = document.querySelector('[data-one-time-selector]')
              if (oneTimeSelector) {
                widgetPriceElement = oneTimeSelector.querySelector('[data-widget-price-sub-price]')
                // console.log('[updateButtonPrice] OTP mode - found in document [data-one-time-selector]:', {
                //   found: !!widgetPriceElement,
                //   content: widgetPriceElement?.textContent?.trim()
                // })
              }
            }
            
            // Check if widget element exists AND has a value
            if (widgetPriceElement) {
              // Prefer `data-cents` over scraped text. See subscription branch above for rationale.
              const widgetCents = widgetPriceElement.dataset?.cents
              if (widgetCents && !isNaN(parseInt(widgetCents, 10))) {
                const centsValue = parseInt(widgetCents, 10)
                if (centsValue > 0) {
                  displayPrice = centsValue / 100
                }
              } else {
                const widgetPriceText = widgetPriceElement.textContent.trim()
                if (widgetPriceText) {
                  const parsedWidgetPrice = parseFloat(widgetPriceText.replace(/[^0-9.]/g, ''))
                  if (!isNaN(parsedWidgetPrice) && parsedWidgetPrice > 0) {
                    displayPrice = parsedWidgetPrice
                  }
                }
              }
            }
            // If widget element doesn't exist, displayPrice stays as oneTimePrice (fallback)
          }
          
          // console.log('[updateButtonPrice] Final displayPrice:', displayPrice)
          
          // Calculate subscription price for the event (needed for sticky cart)
          // This is always calculated regardless of selection for the event
          const productFormComponent = productForm.closest('product-form-component')
          const hasSubZero = productFormComponent?.dataset.hasSubZero === 'true'
          const hasSubSave = productFormComponent?.dataset.hasSubSave === 'true'
          // Prefer variant-level discount (from metafield), fall back to product-level
          const variantDiscountAttr = wrapper.dataset.subscriptionDiscount
          const productDiscountAttr = productFormComponent?.dataset.subscriptionDiscount
          const discountAttr = variantDiscountAttr || productDiscountAttr
          const compareCents = parseFloat(wrapper.dataset.compareCents || '0')
          const subscriptionBasePrice = compareCents > 0 ? compareCents / 100 : oneTimePrice

          // `sub-save` is the US-only exception that continues to use Recharge.
          // Every standard product displays the metafield calculation.
          const sellingPlansSelect = wrapper.querySelector('[name="selling_plan"]')
          const selectedPlan = sellingPlansSelect?.querySelector('option:checked')
          const rechargePrice = selectedPlan?.dataset.price
          
          // Calculate subscription price based on product tags
          let subscriptionPrice = oneTimePrice // Default fallback
          if (hasSubZero) {
            // sub-0: No discount, always use regular price
            subscriptionPrice = oneTimePrice
          } else if (hasSubSave && rechargePrice) {
            // sub-save: Use Recharge allocation price when available
            subscriptionPrice = parseFloat(rechargePrice.replace(/[^0-9.]/g, ''))
          } else if (hasSubSave && !rechargePrice) {
            // sub-save: Fallback to regular price if Recharge hasn't loaded yet
            subscriptionPrice = oneTimePrice
          } else {
            // No metafield percentage means no discount — never assume 20%
            const subscriptionDiscount = parseFloat(discountAttr || '0')
            const discountMultiplier = (100 - subscriptionDiscount) / 100
            subscriptionPrice = subscriptionBasePrice * discountMultiplier
          }
          
          // Format the display price (from widget element)
          const formattedPrice = formatStorePrice(displayPrice)
          const buttonPriceText = `• ${formattedPrice}`
          
          // Store correct button price for protection
          if (!window._priceProtection) {
            window._priceProtection = {}
          }
          window._priceProtection.correctButtonPrice = buttonPriceText
          window._priceProtection.correctDisplayPrice = formattedPrice
          window._priceProtection.isSubscriptionMode = isSubscription // Store selection state
          buttonPriceElement.innerHTML = buttonPriceText
          
          // Update main price container with price from widget element
          updateMainPriceContainer(displayPrice, oneTimePrice, isSubscription)
          
          // Update Afterpay installments
          updateAfterpayInstallments(displayPrice)
          
          // Dispatch custom event for sticky cart to listen to
          // IMPORTANT: Always send the correct subscription price, not the currently displayed price
          // displayPrice: Widget price for one-time purchase (from [data-widget-price-sub-price] inside [data-one-time-selector])
          // oneTimePrice: Regular price (for subscription strikethrough comparison)
          const priceUpdateEvent = new CustomEvent('subscription:price-update', {
            bubbles: true,
            detail: {
              isSubscription: isSubscription,
              subscriptionPrice: subscriptionPrice,
              oneTimePrice: oneTimePrice, // Regular price (for subscription strikethrough)
              displayPrice: displayPrice, // Widget price (for one-time "Try once" display)
              variantId: variantId
            }
          })
          document.dispatchEvent(priceUpdateEvent)
          // console.log('[Subscription Widget] Dispatched price update event:', { isSubscription, subscriptionPrice, oneTimePrice, displayPrice })
        }

        // Store correct prices on window object to persist across morphs
        if (!window._priceProtection) {
          window._priceProtection = {
            correctDisplayPrice: null,
            correctButtonPrice: null,
            isSubscriptionMode: false
          }
        }

        // Install a global protector that FIXES wrong prices immediately
        const installGlobalPriceProtector = () => {
          // console.log('[installGlobalPriceProtector] Starting...')
          
          // Log ALL widget price elements on the page
          const allWidgetSubPriceElements = document.querySelectorAll('[data-widget-price-sub-price]')
          const allWidgetOneTimeElements = document.querySelectorAll('[data-widget-price-onetime]')
          const allOneTimeSelectors = document.querySelectorAll('[data-one-time-selector]')
          // console.log('[installGlobalPriceProtector] All widget elements found:', {
          //   subscription: Array.from(allWidgetSubPriceElements).map(el => ({
          //     element: el,
          //     content: el.textContent.trim(),
          //     parent: el.parentElement?.tagName,
          //     isInOneTimeSelector: !!el.closest('[data-one-time-selector]')
          //   })),
          //   oneTimeDirect: Array.from(allWidgetOneTimeElements).map(el => ({
          //     element: el,
          //     content: el.textContent.trim(),
          //     parent: el.parentElement?.tagName
          //   })),
          //   oneTimeSelectors: Array.from(allOneTimeSelectors).map(sel => ({
          //     selector: sel,
          //     widgetPrice: sel.querySelector('[data-widget-price-sub-price]')?.textContent?.trim()
          //   }))
          // })
          
          const priceContainer = document.querySelector('[ref="priceContainer"]')
          if (!priceContainer) {
            // console.log('[installGlobalPriceProtector] Price container NOT found')
            return
          }
          const subscriptionPriceElement = priceContainer.querySelector('.subscription-price')
          if (!subscriptionPriceElement) {
            // console.log('[installGlobalPriceProtector] Subscription price element NOT found')
            return
          }

          // Find widget price elements
          // Subscription: [data-widget-price-sub-price] in wrapper/subscription section
          const widgetSubscriptionPriceElement = productForm.querySelector('[data-widget-price-sub-price]')
          
          // One-time: [data-widget-price-sub-price] inside [data-one-time-selector]
          // OR fallback to [data-widget-price-onetime] if it exists
          let widgetOneTimePriceElement = null
          const oneTimeSelector = productForm.querySelector('[data-one-time-selector]')
          if (oneTimeSelector) {
            widgetOneTimePriceElement = oneTimeSelector.querySelector('[data-widget-price-sub-price]')
          }
          // Fallback to direct [data-widget-price-onetime] if not found in selector
          if (!widgetOneTimePriceElement) {
            widgetOneTimePriceElement = productForm.querySelector('[data-widget-price-onetime]')
          }
          
          // console.log('[installGlobalPriceProtector] Widget elements in productForm:', {
          //   subscription: {
          //     found: !!widgetSubscriptionPriceElement,
          //     content: widgetSubscriptionPriceElement?.textContent?.trim()
          //   },
          //   oneTime: {
          //     found: !!widgetOneTimePriceElement,
          //     content: widgetOneTimePriceElement?.textContent?.trim(),
          //     location: widgetOneTimePriceElement?.closest('[data-one-time-selector]') ? 'inside [data-one-time-selector]' : 'direct [data-widget-price-onetime]'
          //   }
          // })
          
          if (!widgetSubscriptionPriceElement && !widgetOneTimePriceElement) {
            // console.log('[installGlobalPriceProtector] No widget elements found, returning')
            return
          }

          if (window._globalPriceProtector) {
            window._globalPriceProtector.disconnect()
          }

          window._globalPriceProtector = new MutationObserver((mutations) => {
            // console.log('[MutationObserver] VERSION: 2025-11-27-FIX-APPLIED') // Cache buster check
            
            // Re-query elements in case they were replaced during morph
            const freshWidgetSubscriptionPriceElement = productForm.querySelector('[data-widget-price-sub-price]')
            
            // Re-query one-time element: look in [data-one-time-selector] first, then fallback to direct [data-widget-price-onetime]
            let freshWidgetOneTimePriceElement = null
            const freshOneTimeSelector = productForm.querySelector('[data-one-time-selector]')
            if (freshOneTimeSelector) {
              freshWidgetOneTimePriceElement = freshOneTimeSelector.querySelector('[data-widget-price-sub-price]')
            }
            if (!freshWidgetOneTimePriceElement) {
              freshWidgetOneTimePriceElement = productForm.querySelector('[data-widget-price-onetime]')
            }
            
            // Check which option is currently selected (CRITICAL: Prevents cross-contamination)
            const wrapper = productForm.querySelector('[id^="subscription-variant--"]')
            const currentlySelectedType = wrapper?.querySelector('input[name="purchase_type"]:checked')?.value
            const isSubscriptionSelected = currentlySelectedType === 'autodeliver'
            
            // console.log('[MutationObserver] Current selection state:', {
            //   selectedType: currentlySelectedType,
            //   isSubscriptionSelected: isSubscriptionSelected
            // })
            
            // // Console log to track element state
            // if (freshWidgetOneTimePriceElement) {
            //   const currentText = freshWidgetOneTimePriceElement.textContent.trim()
            //   console.log('[MutationObserver] One-time price element found:', {
            //     exists: true,
            //     hasContent: !!currentText,
            //     content: currentText,
            //     wasEmpty: !window._priceProtection?.otpElementHadContent,
            //     location: freshWidgetOneTimePriceElement.closest('[data-one-time-selector]') ? 'inside [data-one-time-selector]' : 'direct [data-widget-price-onetime]'
            //   })
            // } else {
            //   console.log('[MutationObserver] One-time price element NOT found')
            // }
            
            // Check if OTP element was just added or populated
            let otpElementJustPopulated = false
            
            // First pass: check if element was added or if existing element got content
            mutations.forEach((mutation) => {
              const target = mutation.target
              const isElement = target.nodeType === Node.ELEMENT_NODE
              
              // Check if a widget element was added to DOM
              if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach((node) => {
                  if (node.nodeType === 1) { // Element node
                    // Check for [data-widget-price-onetime]
                    if (node.matches && node.matches('[data-widget-price-onetime]')) {
                      // console.log('[MutationObserver] [data-widget-price-onetime] element ADDED to DOM')
                      otpElementJustPopulated = true
                    }
                    // Check for [data-widget-price-sub-price] inside [data-one-time-selector]
                    if (node.matches && node.matches('[data-one-time-selector]')) {
                      const widgetElement = node.querySelector('[data-widget-price-sub-price]')
                      if (widgetElement && widgetElement.textContent.trim()) {
                        // console.log('[MutationObserver] [data-widget-price-sub-price] inside [data-one-time-selector] ADDED:', widgetElement.textContent.trim())
                        otpElementJustPopulated = true
                      }
                    }
                    // Also check if the added node contains the widget element
                    const widgetElement = node.querySelector && (node.querySelector('[data-widget-price-onetime]') || node.querySelector('[data-one-time-selector] [data-widget-price-sub-price]'))
                    if (widgetElement && widgetElement.textContent.trim()) {
                      // console.log('[MutationObserver] One-time widget element found INSIDE added node:', widgetElement.textContent.trim())
                      otpElementJustPopulated = true
                    }
                  }
                })
              }
              
              // Check if existing element's content changed (only for element nodes)
              if (isElement && freshWidgetOneTimePriceElement) {
                // Check for changes to [data-widget-price-onetime] OR [data-widget-price-sub-price] inside [data-one-time-selector]
                const isOneTimeElementChange = 
                  (target === freshWidgetOneTimePriceElement || target.closest('[data-widget-price-onetime]')) ||
                  (target.closest('[data-one-time-selector]') && target.closest('[data-widget-price-sub-price]'))
                
                if (isOneTimeElementChange) {
                  if (mutation.type === 'characterData' || mutation.type === 'childList') {
                    const currentText = freshWidgetOneTimePriceElement.textContent.trim()
                    // console.log('[MutationObserver] One-time price element content CHANGED:', {
                    //   mutationType: mutation.type,
                    //   newContent: currentText,
                    //   target: target
                    // })
                    if (currentText) {
                      const wasEmpty = !window._priceProtection?.otpElementHadContent
                      if (wasEmpty) {
                        // console.log('[MutationObserver] One-time price element went from EMPTY to HAVING CONTENT:', currentText)
                        otpElementJustPopulated = true
                        window._priceProtection.otpElementHadContent = true
                      }
                    }
                  }
                }
              }
            })
            
            // Check if existing OTP element now has content (was empty before)
            if (freshWidgetOneTimePriceElement && !otpElementJustPopulated) {
              const currentText = freshWidgetOneTimePriceElement.textContent.trim()
              if (currentText) {
                const wasEmpty = !window._priceProtection?.otpElementHadContent
                if (wasEmpty) {
                  // console.log('[MutationObserver] One-time price element NOW HAS CONTENT (was empty):', currentText)
                  otpElementJustPopulated = true
                  window._priceProtection.otpElementHadContent = true
                }
              }
            }
            
            // Second pass: process mutations and update prices if needed
            mutations.forEach((mutation) => {
              // Watch for changes to widget price elements (after DOM morphs)
              const target = mutation.target
              
              // Check if target is an Element node before using closest()
              // Text nodes (characterData mutations) don't have the closest() method
              const isElement = target.nodeType === Node.ELEMENT_NODE
              
              const isOneTimeElementChange = isElement && freshWidgetOneTimePriceElement && (
                (target === freshWidgetOneTimePriceElement || target.closest('[data-widget-price-onetime]')) ||
                (target.closest('[data-one-time-selector]') && target.closest('[data-widget-price-sub-price]'))
              )
              
              const isWidgetPriceChange = isElement && (
                (freshWidgetSubscriptionPriceElement && (target === freshWidgetSubscriptionPriceElement || target.closest('[data-widget-price-sub-price]'))) ||
                (freshWidgetOneTimePriceElement && (
                  (target === freshWidgetOneTimePriceElement || target.closest('[data-widget-price-onetime]')) ||
                  (target.closest('[data-one-time-selector]') && target.closest('[data-widget-price-sub-price]'))
                )) ||
                otpElementJustPopulated // Also trigger if OTP element was just added or populated
              )
              
              // For characterData mutations (text changes), check parent element
              const isCharacterDataChange = mutation.type === 'characterData'
              const parentElement = isCharacterDataChange ? target.parentElement : null
              
              const isParentOneTimeChange = isCharacterDataChange && parentElement && freshWidgetOneTimePriceElement && (
                (parentElement === freshWidgetOneTimePriceElement) ||
                (parentElement.closest && parentElement.closest('[data-widget-price-onetime]')) ||
                (parentElement.closest && parentElement.closest('[data-one-time-selector]'))
              )
              
              const isParentWidgetChange = isCharacterDataChange && parentElement && (
                (freshWidgetSubscriptionPriceElement && (parentElement === freshWidgetSubscriptionPriceElement || (parentElement.closest && parentElement.closest('[data-widget-price-sub-price]')))) ||
                (freshWidgetOneTimePriceElement && (
                  (parentElement === freshWidgetOneTimePriceElement) ||
                  (parentElement.closest && parentElement.closest('[data-widget-price-onetime]')) ||
                  (parentElement.closest && parentElement.closest('[data-one-time-selector]'))
                ))
              )
              
              const isFinalWidgetPriceChange = isWidgetPriceChange || isParentWidgetChange || otpElementJustPopulated
              
              if (isFinalWidgetPriceChange && (mutation.type === 'childList' || mutation.type === 'characterData' || otpElementJustPopulated)) {
                // console.log('[MutationObserver] Widget price change detected:', {
                //   currentSelection: isSubscriptionSelected ? 'subscription' : 'one-time',
                //   otpElementJustPopulated: otpElementJustPopulated,
                //   mutationType: mutation.type,
                //   target: target,
                //   isElement: isElement,
                //   isCharacterDataChange: isCharacterDataChange
                // })
                
                // CRITICAL: Only process price updates that match the current selection
                // This prevents Shopify's one-time discount from overwriting subscription prices
                const isSubscriptionPriceChange = isElement && (target === freshWidgetSubscriptionPriceElement || target.closest('[data-widget-price-sub-price]'))
                const isSubscriptionParentChange = isCharacterDataChange && parentElement && (
                  parentElement === freshWidgetSubscriptionPriceElement ||
                  (parentElement.closest && parentElement.closest('[data-widget-price-sub-price]'))
                )
                const isFinalSubscriptionChange = isSubscriptionPriceChange || isSubscriptionParentChange
                
                const isOneTimePriceChange = isOneTimeElementChange || isParentOneTimeChange || otpElementJustPopulated
                
                // Reject price updates that don't match current selection AND restore correct price
                if (isSubscriptionSelected && isOneTimePriceChange && !isFinalSubscriptionChange) {
                  // console.log('[MutationObserver] REJECTING one-time price update because subscription is selected - RESTORING correct price')
                  
                  // Force restore the correct prices
            
                  
                  return // Don't process this update further
                }
                
                if (!isSubscriptionSelected && isFinalSubscriptionChange && !isOneTimePriceChange) {
                  // console.log('[MutationObserver] REJECTING subscription price update because one-time is selected - RESTORING correct price')
                  
      
                  
                  return // Don't process this update further
                }
                
                // Widget price changed - read the new price and update main price and button
                // This handles when the element goes from empty to having a value after morph
                const isSubscription = isSubscriptionSelected
                
                // Find the active wrapper to get oneTimePrice
                const activeWrapper = productForm.querySelector('[id^="subscription-variant--"]')
                const oneTimePrice = activeWrapper ? getCompareDisplayPrice(activeWrapper) : 0
                
                // Helper: prefer `data-cents` (Integer cents) over scraped text for accuracy.
                const readPriceFromWidget = (el) => {
                  if (!el) return null
                  const cents = el.dataset?.cents
                  if (cents && !isNaN(parseInt(cents, 10))) {
                    return parseInt(cents, 10) / 100
                  }
                  const priceText = el.textContent.trim()
                  if (!priceText) return null
                  const parsed = parseFloat(priceText.replace(/[^0-9.]/g, ''))
                  return isNaN(parsed) ? null : parsed
                }

                let newPrice = null
                if (isSubscription && activeWrapper) {
                  newPrice = getSubscriptionDisplayPrice(activeWrapper)
                } else if (isSubscription && freshWidgetSubscriptionPriceElement) {
                  newPrice = readPriceFromWidget(freshWidgetSubscriptionPriceElement)
                } else if (!isSubscription && freshWidgetOneTimePriceElement) {
                  // For OTP, check if element now has a value (was empty before morph)
                  newPrice = readPriceFromWidget(freshWidgetOneTimePriceElement)
                  if (newPrice !== null) {
                    // Only update if we got a valid price
                    if (newPrice && !isNaN(newPrice) && newPrice > 0) {
                      // Update button price
                      const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
                      if (buttonPriceElement) {
                        const formattedPrice = formatStorePrice(newPrice)
                        const buttonPriceText = `• ${formattedPrice}`
                        buttonPriceElement.innerHTML = buttonPriceText
                        
                        // Update protection object
                        if (!window._priceProtection) {
                          window._priceProtection = {}
                        }
                        window._priceProtection.correctButtonPrice = buttonPriceText
                        window._priceProtection.correctDisplayPrice = formattedPrice
                        window._priceProtection.isSubscriptionMode = false // Store selection state
                      }
                      
                      // Update main price container using the proper function
                      if (activeWrapper) {
                        updateMainPriceContainer(newPrice, oneTimePrice, false)
                      }
                      
                      // Update Afterpay
                      updateAfterpayInstallments(newPrice)
                    }
                    return // Exit early for OTP case
                  }
                }
                
                // For subscription case, update prices
                if (isSubscription && newPrice && !isNaN(newPrice) && newPrice > 0) {
                  // Update button price
                  const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
                  if (buttonPriceElement) {
                    const formattedPrice = formatStorePrice(newPrice)
                    const buttonPriceText = `• ${formattedPrice}`
                    buttonPriceElement.innerHTML = buttonPriceText
                    
                    // Update protection object
                    if (!window._priceProtection) {
                      window._priceProtection = {}
                    }
                    window._priceProtection.correctButtonPrice = buttonPriceText
                    window._priceProtection.correctDisplayPrice = formattedPrice
                    window._priceProtection.isSubscriptionMode = true // Store selection state
                  }
                  
                  // Update main price container using the proper function
                  if (activeWrapper) {
                    updateMainPriceContainer(newPrice, oneTimePrice, true)
                  }
                  
                  // Update Afterpay
                  updateAfterpayInstallments(newPrice)
                }
              }
              
              // Also protect against incorrect changes to button and main price
              if (mutation.type === 'childList' || mutation.type === 'characterData') {
                // Get current selection state for verification
                const wrapper = productForm.querySelector('[id^="subscription-variant--"]')
                const currentlySelectedType = wrapper?.querySelector('input[name="purchase_type"]:checked')?.value
                const isCurrentlySubscriptionSelected = currentlySelectedType === 'autodeliver'
                
                // Only restore prices if the stored state matches current selection
                // This prevents wrong prices from being restored during selection changes
                if (window._priceProtection?.isSubscriptionMode === isCurrentlySubscriptionSelected) {
                  const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
                  if (buttonPriceElement && window._priceProtection?.correctButtonPrice) {
                    const currentButtonText = buttonPriceElement.innerHTML.trim()
                    const correctButtonText = window._priceProtection.correctButtonPrice.trim()
                    if (currentButtonText !== correctButtonText) {
                      // console.log('[MutationObserver] RESTORING button price:', {
                      //   from: currentButtonText,
                      //   to: correctButtonText,
                      //   selectionMatches: true
                      // })
                      buttonPriceElement.innerHTML = window._priceProtection.correctButtonPrice
                    }
                  }

                  if (subscriptionPriceElement && window._priceProtection?.correctDisplayPrice) {
                    const currentPriceText = getVisiblePriceText(subscriptionPriceElement)
                    const correctPriceText = window._priceProtection.correctDisplayPrice.trim()
                    if (currentPriceText !== correctPriceText) {
                      setPriceText(
                        subscriptionPriceElement,
                        window._priceProtection.correctDisplayPrice,
                        'price_sale'
                      )
                    }
                  }
                } else {
                  // console.log('[MutationObserver] NOT restoring prices - selection state mismatch:', {
                  //   storedIsSubscription: window._priceProtection?.isSubscriptionMode,
                  //   currentIsSubscription: isCurrentlySubscriptionSelected
                  // })
                }
              }
            })
          })

          // Observe widget price elements for changes (these get updated after DOM morphs)
          if (widgetSubscriptionPriceElement) {
            // console.log('[installGlobalPriceProtector] Observing subscription widget element:', widgetSubscriptionPriceElement)
            window._globalPriceProtector.observe(widgetSubscriptionPriceElement, {
              childList: true,
              subtree: true,
              characterData: true
            })
          }
          
          if (widgetOneTimePriceElement) {
            // console.log('[installGlobalPriceProtector] Observing one-time widget element:', {
            //   element: widgetOneTimePriceElement,
            //   content: widgetOneTimePriceElement.textContent.trim(),
            //   location: widgetOneTimePriceElement.closest('[data-one-time-selector]') ? 'inside [data-one-time-selector]' : 'direct [data-widget-price-onetime]'
            // })
            window._globalPriceProtector.observe(widgetOneTimePriceElement, {
              childList: true,
              subtree: true,
              characterData: true
            })
            
            // Also observe the [data-one-time-selector] container if the element is inside it
            // This ensures we catch when the element is added or replaced during morphs
            const oneTimeSelectorContainer = widgetOneTimePriceElement.closest('[data-one-time-selector]')
            if (oneTimeSelectorContainer) {
              // console.log('[installGlobalPriceProtector] Also observing [data-one-time-selector] container')
              window._globalPriceProtector.observe(oneTimeSelectorContainer, {
                childList: true,
                subtree: true,
                characterData: true
              })
            }
          } else {
            // console.log('[installGlobalPriceProtector] One-time widget element NOT found, observing productForm for when it gets added')
            // Element doesn't exist yet - watch the productForm for when it gets added
            // This handles the case where the element is added during morph
            window._globalPriceProtector.observe(productForm, {
              childList: true,
              subtree: true,
              characterData: true
            })
            
            // Also watch for [data-one-time-selector] being added
            const oneTimeSelector = productForm.querySelector('[data-one-time-selector]')
            if (oneTimeSelector) {
              // console.log('[installGlobalPriceProtector] Observing existing [data-one-time-selector] for widget element')
              window._globalPriceProtector.observe(oneTimeSelector, {
                childList: true,
                subtree: true,
                characterData: true
              })
            }
          }

          // Also observe the price container and button for protection
          window._globalPriceProtector.observe(priceContainer, {
            childList: true,
            subtree: true,
            characterData: true
          })

          const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
          if (buttonPriceElement) {
            window._globalPriceProtector.observe(buttonPriceElement, {
              childList: true,
              characterData: true
            })
          }
        }

        // Install the protector immediately to catch early price changes
        // Don't wait - we need to catch Shopify discount overwrites in real-time
        installGlobalPriceProtector()

        const updateAfterpayInstallments = (price) => {
          const afterpayElement = document.getElementById('afterpay_instalments')
          if (!afterpayElement) return

          // Calculate installment amount (price divided by 4)
          const installmentAmount = price / 4
          
          afterpayElement.textContent = formatStorePrice(installmentAmount)
        }

        const syncToStickyBar = (isSubscription) => {
          const stickyBar = document.querySelector('[data-sticky-add-to-cart]')
          if (!stickyBar) return
          
          const stickyOneTimeRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="onetime"]')
          const stickySubscriptionRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="subscription"]')
          
          if (isSubscription && stickySubscriptionRadio) {
            stickySubscriptionRadio.checked = true
            stickySubscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }))
          } else if (!isSubscription && stickyOneTimeRadio) {
            stickyOneTimeRadio.checked = true
            stickyOneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }))
          }
        }

        const updateMainPriceContainer = (displayPrice, originalPrice, isSubscription) => {
          const priceContainer = document.querySelector('[ref="priceContainer"]')
          if (!priceContainer) {
            // console.log('[Main Price] Price container not found')
            return
          }

          // Liquid-rendered cents on the header price container are the source of truth.
          const containerSubscriptionPrice = parseCentsToDollars(priceContainer.dataset.subscriptionCents)
          const containerComparePrice = parseCentsToDollars(priceContainer.dataset.compareCents)

          if (isSubscription && containerSubscriptionPrice !== null) {
            displayPrice = containerSubscriptionPrice
          }

          if (isSubscription && containerComparePrice !== null) {
            originalPrice = containerComparePrice
          }

          // Get product tag data to know which price elements to target
          const productFormComponent = productForm.closest('product-form-component')
          const hasSubZero = productFormComponent?.dataset.hasSubZero === 'true'
          const hasSubSave = productFormComponent?.dataset.hasSubSave === 'true'
          
          const formatPrice = (price) => formatStorePrice(price)

          // console.log('[Main Price] Updating price:', { displayPrice, originalPrice, isSubscription, hasSubZero, hasSubSave })

          const compareAtPriceElement = priceContainer.querySelector('.regular-price[data-price-type="compare-at"]')
          const compareAtGroup = priceContainer.querySelector('[data-compare-at-group]')
          const setOtpCompareAtVisible = (visible) => {
            if (compareAtGroup) {
              compareAtGroup.hidden = !visible
              compareAtGroup.style.display = visible ? 'inline' : 'none'
            }

            if (compareAtPriceElement) {
              compareAtPriceElement.hidden = !visible
              compareAtPriceElement.style.display = visible ? 'block' : 'none'
            }
          }

          // sub-0 stays on `.price`. `sub-save` now uses `.subscription-price`
          // like other subscribe products (Liquid metafield math).
          if (hasSubZero || hasSubSave) {
            const priceElement =
              priceContainer.querySelector('.subscription-price') || priceContainer.querySelector('.price')
            if (priceElement) {
              setPriceText(priceElement, formatPrice(displayPrice), 'price_sale')
            }

            syncOneTimeComparePrice(priceContainer)
            setOtpCompareAtVisible(!isSubscription)
            
            // Handle badge visibility for sub-save products
            if (hasSubSave) {
              const subscriptionBadge = priceContainer.querySelector('.subscription-badge')
              if (subscriptionBadge) {
                // Check if product has both options or is subscription-only
                const oneTimeRadio = document.querySelector('input[name="purchase_type"][value=""]')
                const subscriptionRadio = document.querySelector('input[name="purchase_type"][value="autodeliver"]')
                const hasOneTimeOption = oneTimeRadio !== null
                const isSubscriptionOnly = subscriptionRadio !== null && !hasOneTimeOption
                
                if (isSubscriptionOnly) {
                  // Subscription-only product - always show badge
                  subscriptionBadge.style.display = ''
                  // console.log('[Main Price] Showing badge for sub-save subscription-only product')
                } else if (isSubscription) {
                  // Has both options and subscription is selected
                  subscriptionBadge.style.display = ''
                  // console.log('[Main Price] Showing badge for sub-save subscription')
                } else {
                  // Has both options and one-time is selected
                  subscriptionBadge.style.display = 'none'
                  // console.log('[Main Price] Hiding badge for sub-save one-time')
                }
              }
            }
            return
          }

          // For regular subscription products
          const subscriptionPriceElement = priceContainer.querySelector('.subscription-price')
          const onetimePriceElement = priceContainer.querySelector('.regular-price[data-price-type="onetime"]')
          const regularPriceElement = onetimePriceElement || priceContainer.querySelector('.regular-price')
          const subscriptionBadge = priceContainer.querySelector('.subscription-badge')
          const savingsElement = priceContainer.querySelector('[data-price-savings]')
          
          if (!subscriptionPriceElement) {
            // console.log('[Main Price] .subscription-price element not found')
            return
          }

          // `compare-price-new-logic` products strike their compare-at price, which Liquid
          // stamps on the element. The widget only knows the one-time price, so
          // without this it would overwrite the struck figure on every toggle.
          const struckOverride = regularPriceElement ? parseFloat(regularPriceElement.dataset.struckPrice) : NaN
          const struckPrice = Number.isNaN(struckOverride) ? Number(originalPrice) : struckOverride
          const hasDiscount = Number(displayPrice) < struckPrice

          // Show displayPrice (from widget element) as main price
          // displayPrice comes from [data-widget-price-sub-price] when subscription is selected
          // or from [data-widget-price-onetime] when one-time is selected
          const formattedDisplayPrice = formatPrice(displayPrice)
          setPriceText(subscriptionPriceElement, formattedDisplayPrice, 'price_sale')
          
          // Store correct display price for protection
          if (!window._priceProtection) {
            window._priceProtection = {}
          }
          window._priceProtection.correctDisplayPrice = formattedDisplayPrice
          window._priceProtection.isSubscriptionMode = isSubscription

          if (isSubscription) {
            // Subscription selected: strike the base price, but only when there is a real save
            const comparePriceElement = regularPriceElement || priceContainer.querySelector('.compare-at-price')
            if (comparePriceElement) {
              if (hasDiscount) {
                setPriceText(comparePriceElement, formatPrice(struckPrice), 'price_regular')
                comparePriceElement.style.textDecoration = 'line-through'
                comparePriceElement.style.display = ''
              } else {
                comparePriceElement.textContent = ''
                comparePriceElement.style.textDecoration = 'none'
                comparePriceElement.style.display = 'none'
              }
            }

            setOtpCompareAtVisible(false)
            
            // Show subscription badge
            if (subscriptionBadge) {
              subscriptionBadge.style.display = hasDiscount ? '' : 'none'
            }

            // Savings copy is rendered against the struck price, so it only holds
            // while there is one.
            if (savingsElement) {
              savingsElement.style.display = hasDiscount ? '' : 'none'
            }
            
            // console.log('[Main Price] Updated to subscription price')
          } else {
            // One-time selected: still show subscription price, but hide regular price and badge
            const comparePriceElement = regularPriceElement || priceContainer.querySelector('.compare-at-price')
            if (comparePriceElement) {
              if (!Number.isNaN(struckOverride) && struckOverride > Number(displayPrice)) {
                setPriceText(comparePriceElement, formatPrice(struckOverride), 'price_regular')
                comparePriceElement.style.textDecoration = 'line-through'
                comparePriceElement.style.display = ''
              } else {
                comparePriceElement.textContent = ''
                comparePriceElement.style.textDecoration = 'none'
                comparePriceElement.style.display = 'none'
              }
            }

            if (compareAtPriceElement) {
              compareAtPriceElement.style.textDecoration = 'line-through'
            }

            setOtpCompareAtVisible(Number.isNaN(struckOverride))
            
            // Hide subscription badge
            if (subscriptionBadge) {
              subscriptionBadge.style.display = 'none'
            }

            // The subscription saving no longer applies on one-time purchase.
            if (savingsElement) {
              savingsElement.style.display = 'none'
            }
          }

          subscriptionPriceElement.style.textDecoration = 'none'
        }
  
        sellingPlans.forEach(el => el.setAttribute('form', productFormId))
  
        variants.forEach(wrapper => {
          const purchaseTypes = wrapper.querySelectorAll(
            'input[name="purchase_type"]'
          )
          purchaseTypes.forEach(purchaseType => {
            purchaseType.addEventListener('click', e => {
              // switch toggle
              productForm.querySelectorAll('.rc_block__type').forEach(el => {
                // override theme js
                el.style.display = ''
                el.classList.remove('rc_block__type--active')
              })
  
              const purchaseType = e.target
              const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
              const block = purchaseType.closest('.rc_block__type')
  
              // handle subscription option not output
              block && block.classList.add('rc_block__type--active')
  
              lastPurchaseType = purchaseType.value
              const purchaseTypes = wrapper.querySelectorAll('input[name="purchase_type"]')

              if (isSubscriptionPurchase(wrapper, lastPurchaseType)) {
                sellingPlans.disabled = false
                updatePriceDisplay(wrapper)
                updateButtonPrice(wrapper, true) // Update button to show subscription price (also dispatches event)
                syncToStickyBar(true) // Sync to sticky bar
              } else {
                sellingPlans.disabled = true
                resetPriceDisplay(wrapper)
                
                // Always update immediately (will use fallback if widget element is empty)
                updateButtonPrice(wrapper, false)
                
                // Also set up a watcher to check if widget element gets populated after morph
                // Check multiple times as morph might happen at different times
                let checkCount = 0
                const maxChecks = 10 // Check up to 10 times (2 seconds total)
                const checkInterval = setInterval(() => {
                  checkCount++
                  // Look for widget element: first in [data-one-time-selector], then direct [data-widget-price-onetime]
                  let widgetOneTimeElement = null
                  const oneTimeSelector = productForm.querySelector('[data-one-time-selector]') || document.querySelector('[data-one-time-selector]')
                  if (oneTimeSelector) {
                    widgetOneTimeElement = oneTimeSelector.querySelector('[data-widget-price-sub-price]')
                  }
                  if (!widgetOneTimeElement) {
                    widgetOneTimeElement = productForm.querySelector('[data-widget-price-onetime]') || document.querySelector('[data-widget-price-onetime]')
                  }
                  
                  if (widgetOneTimeElement && (widgetOneTimeElement.dataset?.cents || widgetOneTimeElement.textContent.trim())) {
                    // Widget element now has a value, update prices with the widget price.
                    // Prefer `data-cents` (Integer cents from Liquid) over scraped text.
                    let widgetPrice
                    const cents = widgetOneTimeElement.dataset?.cents
                    if (cents && !isNaN(parseInt(cents, 10))) {
                      widgetPrice = parseInt(cents, 10) / 100
                    } else {
                      const widgetPriceText = widgetOneTimeElement.textContent.trim()
                      widgetPrice = parseFloat(widgetPriceText.replace(/[^0-9.]/g, ''))
                    }
                    
                    // console.log('[Initial Check] Widget element found and populated:', {
                    //   content: widgetPriceText,
                    //   parsed: widgetPrice,
                    //   location: widgetOneTimeElement.closest('[data-one-time-selector]') ? 'inside [data-one-time-selector]' : 'direct [data-widget-price-onetime]'
                    // })
                    
                    if (!isNaN(widgetPrice) && widgetPrice > 0) {
                      // Update button price
                      const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
                      if (buttonPriceElement) {
                        const formattedPrice = formatStorePrice(widgetPrice)
                        const buttonPriceText = `• ${formattedPrice}`
                        buttonPriceElement.innerHTML = buttonPriceText
                        
                        // Update protection object
                        if (!window._priceProtection) {
                          window._priceProtection = {}
                        }
                        window._priceProtection.correctButtonPrice = buttonPriceText
                        window._priceProtection.correctDisplayPrice = formattedPrice
                      }
                      
                      // Update main price container
                      const oneTimePrice = getCompareDisplayPrice(wrapper)
                      updateMainPriceContainer(widgetPrice, oneTimePrice, false)
                      
                      // Update Afterpay
                      updateAfterpayInstallments(widgetPrice)
                      
                      // Stop checking once we've updated
                      clearInterval(checkInterval)
                    }
                  }
                  
                  // Stop checking after max attempts
                  if (checkCount >= maxChecks) {
                    clearInterval(checkInterval)
                  }
                }, 200) // Check every 200ms
                
                syncToStickyBar(false)
              }
            })
        })

        // Add event listener for delivery frequency dropdown changes (e.g., every 30 days -> every 60 days)
        variants.forEach(wrapper => {
          const sellingPlansSelect = wrapper.querySelector('[name="selling_plan"]')
          if (sellingPlansSelect) {
            sellingPlansSelect.addEventListener('change', () => {
              // console.log('[Subscription Widget] Delivery frequency dropdown changed')
              
              // Check if subscription is currently selected
              const subscriptionRadio = wrapper.querySelector('input[name="purchase_type"][value="autodeliver"]:checked')
              
              if (subscriptionRadio) {
                // Update price display with new delivery frequency's price
                updatePriceDisplay(wrapper, null, productForm)
                updateButtonPrice(wrapper, true) // Also dispatches event for sticky cart
                
                // console.log('[Subscription Widget] Prices updated for new delivery frequency')
              }
            })
          }
        })
      })

        // Listen for variant update events from the theme
        const closestSection = productForm.closest('.shopify-section, dialog')
        if (closestSection) {
          // console.log('Setting up variant update listener for:', productForm)
          
          closestSection.addEventListener('variant:update', (event) => {
            const variantResource = event.detail.resource
            const html = event.detail.data?.html
            
            // Get the correct price from the fetched HTML or variant resource
            let correctPrice = null
            if (html) {
              const htmlWrapper = html.querySelector(`[id="subscription-variant--${variantResource.id}"]`)
              if (htmlWrapper && htmlWrapper.dataset.price) {
                correctPrice = htmlWrapper.dataset.price
              }
              if (!correctPrice) {
                const htmlPriceContainer = html.querySelector('[ref="priceContainer"]')
                if (htmlPriceContainer) {
                  const htmlRegularPriceElement = htmlPriceContainer.querySelector('.regular-price')
                  if (htmlRegularPriceElement) {
                    correctPrice = htmlRegularPriceElement.textContent.trim()
                  }
                }
              }
            }
            if (!correctPrice) {
              const newVariantPrice = variantResource.price / 100
              correctPrice = formatStorePrice(newVariantPrice)
            }
            
            const priceToUpdate = correctPrice
            
            setTimeout(() => {
              const freshProductForm = closestSection.querySelector('form[action^="/cart"]:not([id*="instal"])')
              if (!freshProductForm) return
              
              // Look for existing wrapper in DOM for this variant
              let activeWrapper = freshProductForm.querySelector(`[id="subscription-variant--${variantResource.id}"]`)
              if (!activeWrapper) {
                activeWrapper = freshProductForm.querySelector(`[data-variant-id="${variantResource.id}"]`)
              }
              if (!activeWrapper) {
                const freshWrappers = freshProductForm.querySelectorAll('[id^="subscription-variant--"]')
                freshWrappers.forEach(wrapper => {
                  if (window.getComputedStyle(wrapper).display !== 'none') {
                    activeWrapper = wrapper
                  }
                })
              }
              if (!activeWrapper) {
                activeWrapper = freshProductForm.querySelector('.subscription-variant--active')
              }
              
              // Helper: insert a wrapper from fetched HTML and fully initialize it
              const insertWrapperFromHTML = (htmlWrapper, replaceTarget) => {
                const newWrapper = htmlWrapper.cloneNode(true)
                newWrapper.style.display = ''
                newWrapper.style.position = 'relative'
                newWrapper.classList.add('subscription-variant--active')
                
                if (replaceTarget) {
                  replaceTarget.replaceWith(newWrapper)
                } else {
                  // Remove any existing old wrappers
                  freshProductForm.querySelectorAll('[id^="subscription-variant--"]').forEach(w => w.remove())
                  const subscriptionWidgetContainer = freshProductForm.querySelector('.subscription-widget, .subscription-widget--custom')
                  if (subscriptionWidgetContainer) {
                    subscriptionWidgetContainer.innerHTML = ''
                    subscriptionWidgetContainer.appendChild(newWrapper)
                  } else {
                    const variantIdInput = freshProductForm.querySelector('[name="id"][ref="variantId"]')
                    if (variantIdInput) {
                      variantIdInput.parentNode.insertBefore(newWrapper, variantIdInput)
                    }
                  }
                }
                
                // Link selling_plan inputs to the product form so they submit with it
                newWrapper.querySelectorAll('[name="selling_plan"]').forEach(el => {
                  el.setAttribute('form', productFormId)
                })
                
                // Re-attach purchase type click handlers (mirrors the original init logic)
                const newPurchaseTypes = newWrapper.querySelectorAll('input[name="purchase_type"]')
                newPurchaseTypes.forEach(pt => {
                  pt.addEventListener('click', e => {
                    productForm.querySelectorAll('.rc_block__type').forEach(el => {
                      el.style.display = ''
                      el.classList.remove('rc_block__type--active')
                    })
                    const clickedPt = e.target
                    const spSelect = newWrapper.querySelector('[name="selling_plan"]')
                    const block = clickedPt.closest('.rc_block__type')
                    if (block) block.classList.add('rc_block__type--active')
                    
                    lastPurchaseType = clickedPt.value
                    
                    if (isSubscriptionPurchase(newWrapper, lastPurchaseType)) {
                      if (spSelect) spSelect.disabled = false
                      updatePriceDisplay(newWrapper)
                      updateButtonPrice(newWrapper, true)
                      syncToStickyBar(true)
                    } else {
                      if (spSelect) spSelect.disabled = true
                      resetPriceDisplay(newWrapper)
                      updateButtonPrice(newWrapper, false)
                      syncToStickyBar(false)
                    }
                  })
                })
                
                // Re-attach selling plan (frequency) change listener
                const spSelect = newWrapper.querySelector('[name="selling_plan"]')
                if (spSelect) {
                  spSelect.addEventListener('change', () => {
                    const subRadio = newWrapper.querySelector('input[name="purchase_type"][value="autodeliver"]:checked')
                    if (subRadio) {
                      updatePriceDisplay(newWrapper, null, productForm)
                      updateButtonPrice(newWrapper, true)
                    }
                  })
                }
                
                // Auto-select subscription option and first frequency
                setTimeout(() => {
                  const subscriptionHeader = newWrapper.querySelector('.subscription-option-header input[type="radio"]')
                  if (subscriptionHeader) {
                    subscriptionHeader.click()
                    const frequencyDropdown = newWrapper.querySelector('.frequency-dropdown')
                    if (frequencyDropdown && frequencyDropdown.options.length > 0) {
                      frequencyDropdown.selectedIndex = 0
                      frequencyDropdown.dispatchEvent(new Event('change', { bubbles: true }))
                    }
                  }
                }, 50)
                
                return newWrapper
              }
              
              // If no wrapper exists in DOM for this variant, pull it from the fetched HTML.
              // This handles switching from a non-subscription variant (e.g. 300g, removed on init)
              // to a subscription variant (e.g. 1kg).
              if (!activeWrapper && html) {
                const htmlWrapper = html.querySelector(`[id="subscription-variant--${variantResource.id}"]`)
                if (htmlWrapper) {
                  activeWrapper = insertWrapperFromHTML(htmlWrapper, null)
                }
              }
              
              // If the existing wrapper belongs to a different variant, replace it with
              // the correct one from fetched HTML (e.g. switching 1kg -> 300g or vice versa)
              if (activeWrapper && activeWrapper.dataset.variantId !== String(variantResource.id) && html) {
                const htmlWrapper = html.querySelector(`[id="subscription-variant--${variantResource.id}"]`)
                if (htmlWrapper) {
                  activeWrapper = insertWrapperFromHTML(htmlWrapper, activeWrapper)
                }
              }
              
              if (activeWrapper) {
                activeWrapper.dataset.price = priceToUpdate
                
                // Update variant-level discount from fetched HTML so JS uses the correct value
                if (html) {
                  const htmlWrapper = html.querySelector(`[id="subscription-variant--${variantResource.id}"]`)
                  if (htmlWrapper) {
                    activeWrapper.dataset.subscriptionDiscount = htmlWrapper.dataset.subscriptionDiscount || '0'
                    activeWrapper.dataset.subscriptionCents = htmlWrapper.dataset.subscriptionCents || ''
                    activeWrapper.dataset.compareCents = htmlWrapper.dataset.compareCents || ''
                  }
                }
                
                // Update selling plan data if available
                const sellingPlansSelect = activeWrapper.querySelector('[name="selling_plan"]')
                
                if (
                  sellingPlansSelect &&
                  sellingPlansSelect.tagName === 'SELECT' &&
                  event.detail.resource.selling_plan_allocations &&
                  event.detail.resource.selling_plan_allocations.length > 0
                ) {
                  sellingPlansSelect.innerHTML = ''

                  const productFormComponent = activeWrapper.closest('product-form-component')
                  const hasSubZero = productFormComponent?.dataset.hasSubZero === 'true'
                  // Prefer variant-level discount, fall back to product-level
                  const variantDiscount = activeWrapper.dataset.subscriptionDiscount
                  const metafieldDiscount = parseFloat(variantDiscount || productFormComponent?.dataset.subscriptionDiscount || '20')
                  const variantRegularPrice = event.detail.resource.price
                  
                  event.detail.resource.selling_plan_allocations.forEach((allocation, index) => {
                    const option = document.createElement('option')
                    option.value = allocation.selling_plan_id

                    // Subscription price comes from the metafield percentage only, never
                    // from the Recharge allocation price.
                    const metafieldDiscount = activeWrapper.dataset.subscriptionDiscount
                      ? parseFloat(activeWrapper.dataset.subscriptionDiscount)
                      : null

                    const compareCents = parseFloat(activeWrapper.dataset.compareCents || '0')
                    const subscriptionBaseCents = compareCents > 0 ? compareCents : variantRegularPrice
                    let calculatedPrice = variantRegularPrice
                    let discountPercentage = '0%'

                    if (!hasSubZero && metafieldDiscount > 0) {
                      calculatedPrice = Math.round((subscriptionBaseCents * (100 - metafieldDiscount)) / 100)
                      discountPercentage = `${metafieldDiscount}%`
                    }

                    option.dataset.price = formatStorePrice(calculatedPrice / 100)
                    option.dataset.discount = discountPercentage
                    option.textContent = `Subscription Plan ${allocation.selling_plan_id}`
                    sellingPlansSelect.appendChild(option)
                  })
                  
                  if (sellingPlansSelect.options.length > 0) {
                    sellingPlansSelect.selectedIndex = 0
                    sellingPlansSelect.dispatchEvent(new Event('change', { bubbles: true }))
                  }
                }

                // Update the discount badge and benefit savings from metafield pricing.
                const selectedPlanOption = sellingPlansSelect?.querySelector('option:checked')
                const discountFromPlan = parseFloat(
                  (selectedPlanOption?.dataset?.discount || '').replace('%', '')
                )
                const variantDiscountPercent = !isNaN(discountFromPlan) && discountFromPlan > 0
                  ? discountFromPlan
                  : parseFloat(activeWrapper.dataset.subscriptionDiscount || '0')

                if (variantDiscountPercent > 0) {
                  const discountBadge = activeWrapper.querySelector('.discount-badge')
                  if (discountBadge) {
                    discountBadge.textContent = `SAVE ${variantDiscountPercent}%`
                  }
                  
                  const compareCents = parseFloat(activeWrapper.dataset.compareCents || '0')
                  const variantPrice = parseFloat(priceToUpdate.replace(/[^0-9.]/g, ''))
                  const savingsBase = compareCents > 0 ? compareCents / 100 : variantPrice
                  if (!isNaN(savingsBase) && savingsBase > 0) {
                    const savingsAmount = savingsBase * (variantDiscountPercent / 100)
                    const formattedSavings = formatStorePrice(savingsAmount)
                    const benefitSavingsElement = activeWrapper.querySelector('.benefit-item span u')
                    if (benefitSavingsElement) {
                      benefitSavingsElement.textContent = formatCopy(
                        'save_amount',
                        { __AMOUNT__: formattedSavings },
                        `SAVE ${formattedSavings}`
                      )
                    }
                  }
                }

                const currentPurchaseType = activeWrapper.querySelector('input[name="purchase_type"]:checked')
                const purchaseTypes = activeWrapper.querySelectorAll('input[name="purchase_type"]')
                
                // Replace the price container from server HTML so the correct elements
                // (.subscription-price + .regular-price + .subscription-badge for subscription,
                //  vs .price for non-subscription) are in the DOM before JS updates run.
                if (html) {
                  const newPriceContainer = html.querySelector('product-price [ref="priceContainer"]')
                  const currentPriceContainer = document.querySelector('product-price [ref="priceContainer"]')
                  if (newPriceContainer && currentPriceContainer) {
                    currentPriceContainer.replaceWith(newPriceContainer.cloneNode(true))
                    syncOneTimeComparePrice(document.querySelector('product-price [ref="priceContainer"]'))
                  }
                }
                
                updatePriceDisplay(activeWrapper, null, freshProductForm)
                resetPriceDisplay(activeWrapper, freshProductForm)
                
                // Update button price based on what's selected
                if (isSubscriptionPurchase(activeWrapper, currentPurchaseType && currentPurchaseType.value)) {
                  updateButtonPrice(activeWrapper, true)
                } else {
                  updateButtonPrice(activeWrapper, false)
                }
              } else {
                const buttonPriceElement = freshProductForm.querySelector('[ref="buttonPrice"]')
                if (buttonPriceElement) {
                  const numericPrice = parseFloat(priceToUpdate.replace(/[^0-9.]/g, ''))
                  buttonPriceElement.innerHTML = `• ${priceToUpdate}`
                  updateAfterpayInstallments(numericPrice)
                  updateMainPriceContainer(numericPrice, numericPrice, false)
                }
              }
              
              // FIX 2: Replace the sticky bar's subscription options from the fetched HTML
              // so the radios match the current variant's subscription availability.
              if (html) {
                const stickyBar = document.querySelector('[data-sticky-add-to-cart]')
                if (stickyBar) {
                  const newStickyBar = html.querySelector('[data-sticky-add-to-cart]')
                  if (newStickyBar) {
                    // Sync the data-no-subscription attribute (affects mobile layout CSS)
                    if (newStickyBar.hasAttribute('data-no-subscription')) {
                      stickyBar.setAttribute('data-no-subscription', '')
                    } else {
                      stickyBar.removeAttribute('data-no-subscription')
                    }
                    
                    const currentSubOptions = stickyBar.querySelector('.sticky-add-to-cart__subscription')
                    const newSubOptions = newStickyBar.querySelector('.sticky-add-to-cart__subscription')
                    if (currentSubOptions && newSubOptions) {
                      currentSubOptions.innerHTML = newSubOptions.innerHTML
                    } else if (!currentSubOptions && newSubOptions) {
                      const stickyContent = stickyBar.querySelector('.sticky-add-to-cart__content')
                      if (stickyContent) {
                        const subDiv = document.createElement('div')
                        subDiv.className = newSubOptions.className
                        subDiv.innerHTML = newSubOptions.innerHTML
                        stickyContent.appendChild(subDiv)
                      }
                    } else if (currentSubOptions && !newSubOptions) {
                      currentSubOptions.remove()
                    }
                    
                    // Re-run sticky bar's subscription listener setup and main form listener
                    // setup so the new radio buttons are wired up
                    if (typeof stickyBar.setupSubscriptionListeners === 'function') {
                      stickyBar.setupSubscriptionListeners()
                    }
                    if (typeof stickyBar.setupMainSubscriptionListeners === 'function') {
                      stickyBar.setupMainSubscriptionListeners()
                    }
                    
                    // Sync the checked state to match what the main widget has selected
                    const mainSubChecked = activeWrapper && activeWrapper.querySelector('input[name="purchase_type"][value="autodeliver"]:checked')
                    const stickySubRadio = stickyBar.querySelector('#sticky-subscription')
                    const stickyOTPRadio = stickyBar.querySelector('#sticky-onetime')
                    if (mainSubChecked && stickySubRadio) {
                      stickySubRadio.checked = true
                    } else if (stickyOTPRadio) {
                      stickyOTPRadio.checked = true
                    }
                    
                    // Update sticky bar pricing
                    if (typeof stickyBar.updateSubscriptionPricing === 'function') {
                      stickyBar.updateSubscriptionPricing()
                    }
                  }
                }
              }
              
              setTimeout(() => {
                installGlobalPriceProtector()
              }, 200)
            }, 150)
          })
        } else {
          console.log('No closest section found for:', productForm)
        }
  
        variants.forEach(wrapper => {
          if (wrapper.className.indexOf('subscription-variant--active') === -1) {
            wrapper.remove()
          } else if (isSubscriptionOnlyWrapper(wrapper)) {
            const purchaseType = wrapper.querySelector(
              'input[name="purchase_type"].rc_radio__autodeliver'
            )
            // console.log("purchaseType",purchaseType)
            // trigger theme js things
            purchaseType.click()
  
            setTimeout(() => {
              // again for good measure
              purchaseType.click()
            }, 500)
          }
        })
      })
    })
  })()
